Ext.ns('mx.comp');

mx.comp.Applet = Ext.extend(Ext.Panel, {
    layout: 'fit',
    tpl: new Ext.XTemplate(
        '<object id="object_{id}"\n' +
            'classid="{classid}"> name="jsap" id="jsap"\n' +
            '<param name="archive" value="{archive}">\n' +
            '<param name="codebase" value="{codebase}">\n' +
            '<param name="code" value="{code}">\n' +
            '<param name="mayscript" value="yes"/>\n' +
            '<param name="scriptable" value="true"/>\n' +
            '<tpl for="params">' +
            '<param name="{name}" value="{value}"/>\n' +
            '</tpl>' +
            '</object>'
    ),

    afterRender: function() {
        mx.comp.Applet.superclass.afterRender.apply(this, arguments);

        this.tpl.overwrite(this.body, this);

        this.objectTagEl = Ext.get('object_' + this.id);

        this.on(
            'resize',
            function(panel, w, h) {
                this.objectTagEl.setSize(w, h);
            },
            this
        );
    },
});

Ext.reg('mx_applet', mx.comp.Applet);
